var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Col, ErrorModal, Modal, Row, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekTextField } from "../inputs";
import { aresDataSynchronize, aresDataSynchronizeAll, } from "../../api/aresService";
import { ErrorType } from "../../types/ErrorType";
var PublisherSynchronize = function () {
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _a = useState(""), companyNumber = _a[0], setCompanyNumber = _a[1];
    var _b = useState(false), aresDataSynchronizeModalOpen = _b[0], setAresDataSynchronizeModalOpen = _b[1];
    var _c = useState(false), aresDataSynchronizeErrorModalOpen = _c[0], setAresDataSynchronizeErrorModalOpen = _c[1];
    var _d = useState(""), aresDataSynchronizeModalMessage = _d[0], setAresDataSynchronizeModalMessage = _d[1];
    var _e = useState(""), aresDataSynchronizeErrorModalMessage = _e[0], setAresDataSynchronizeErrorModalMessage = _e[1];
    var synchronizeAresData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var aresDataSynchronizeResponse, error_1, errors, currentError, errorMessage;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, aresDataSynchronize(ky, companyNumber)];
                case 1:
                    aresDataSynchronizeResponse = _c.sent();
                    if (aresDataSynchronizeResponse.aresUpdateId) {
                        setAresDataSynchronizeModalMessage(formatMessage({ id: "ui-br-publishers.admin.ares.synchronize.success" }, {
                            aresUpdateRequestUrl: "br-publishers/ares-updates?detail=".concat(aresDataSynchronizeResponse.aresUpdateId),
                        }));
                    }
                    else {
                        setAresDataSynchronizeModalMessage(formatMessage({
                            id: "ui-br-publishers.admin.ares.synchronize.success.no.update",
                        }));
                    }
                    setAresDataSynchronizeModalOpen(true);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _c.sent();
                    console.error("Error synchronizing Ares data:", error_1);
                    return [4 /*yield*/, ((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.json())];
                case 3:
                    errors = _c.sent();
                    currentError = (_b = errors === null || errors === void 0 ? void 0 : errors.errors) === null || _b === void 0 ? void 0 : _b[0];
                    errorMessage = "";
                    if (currentError.type === ErrorType.ARES_DATA_NOT_FOUND) {
                        errorMessage = formatMessage({ id: "ui-br-publishers.admin.ares.synchronize.error.not.found" }, { companyNumberError: companyNumber });
                    }
                    else {
                        errorMessage = formatMessage({ id: "ui-br-publishers.admin.ares.synchronize.error" }, { error: "".concat(error_1.message) });
                    }
                    setAresDataSynchronizeErrorModalMessage(errorMessage);
                    setAresDataSynchronizeErrorModalOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var synchronizeAresDataAll = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, aresDataSynchronizeAll(ky)];
                case 1:
                    _a.sent();
                    setAresDataSynchronizeModalMessage(formatMessage({
                        id: "ui-br-publishers.admin.ares.synchronize.all.success",
                    }));
                    setAresDataSynchronizeModalOpen(true);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    console.error("Error synchronizing Ares data:", error_2);
                    errorMessage = formatMessage({ id: "ui-br-publishers.admin.ares.synchronize.error" }, { error: "".concat(error_2.message) });
                    setAresDataSynchronizeErrorModalMessage(errorMessage);
                    setAresDataSynchronizeErrorModalOpen(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(FormattedMessage, { id: "ui-br-publishers.admin.ares.synchronize.title", tagName: "h1" }),
        React.createElement(Modal, { label: React.createElement(FormattedMessage, { id: "ui-br-publishers.admin.ares.synchronize.title" }), open: aresDataSynchronizeModalOpen, onClose: function () { return setAresDataSynchronizeModalOpen(false); }, dismissible: true }, aresDataSynchronizeModalMessage),
        React.createElement(ErrorModal, { label: React.createElement(FormattedMessage, { id: "ui-br-publishers.admin.ares.synchronize.title" }), open: aresDataSynchronizeErrorModalOpen, content: aresDataSynchronizeErrorModalMessage, onClose: function () { return setAresDataSynchronizeErrorModalOpen(false); }, dismissible: true }),
        React.createElement(Row, { style: { display: "flex", alignItems: "center", gap: "10px" } },
            React.createElement(Col, null,
                React.createElement(RecekTextField, { labelId: "ui-br-publishers.admin.ares.synchronize.input.company.number", onChange: function (e) { return setCompanyNumber(e.target.value); }, name: "aresDataSynchronizeCompanyNumber", value: companyNumber, required: true })),
            React.createElement(Col, null,
                React.createElement(Button, { buttonStyle: "primary", onClick: function () { return synchronizeAresData(); } },
                    React.createElement(FormattedMessage, { id: "ui-br-publishers.admin.ares.synchronize.button.synchronize" })))),
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(Button, { buttonStyle: "primary", onClick: function () { return synchronizeAresDataAll(); } },
                    React.createElement(FormattedMessage, { id: "ui-br-publishers.admin.ares.synchronize.button.synchronize.all" }))))));
};
export default PublisherSynchronize;
